import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { TbCrown } from "react-icons/tb";
import AuthShell from "../v2/auth/AuthShell";
import { isAuthenticated, rememberPostLoginPath } from "../services/authService";
import { api } from "../v2/lib/api";
import { startProCheckout } from "../utils/billing";

// /upgrade — a shareable link (emails, the marketing site) into the same Pro checkout the
// in-app "Upgrade to Pro" buttons start.
//
// Signed out: send them to sign in, and Login brings them back here afterwards.
// Already Pro: straight to the dashboard — starting checkout would sell them a second
// subscription, and the in-app buttons are never shown to Pro tenants for that reason.
const LUpgrade = () => {
  const navigate = useNavigate();
  // React 18 StrictMode runs effects twice in development; two checkout sessions per
  // visit is harmless but noisy, so only start once.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    if (!isAuthenticated()) {
      rememberPostLoginPath("/upgrade");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const plan = await api.get("s1/api/entitlements");
        if (plan && plan.is_pro && !plan.on_trial) {
          navigate("/dashboard", { replace: true });
          return;
        }
      } catch (e) {
        // Plan unknown: carry on to checkout rather than strand them here.
      }
      const redirected = await startProCheckout();
      if (!redirected) navigate("/dashboard", { replace: true });
    })();
  }, [navigate]);

  return (
    <AuthShell brand={false}>
      <div className="nf">
        <div>
          <div className="nf-mark"><TbCrown size={26} /></div>
          <h1>Taking you to checkout…</h1>
          <p>One moment while we open the Pipsqueak Pro checkout.</p>
        </div>
      </div>
    </AuthShell>
  );
};

export default LUpgrade;
